class SMFormHelper {
  
  static hourUnitOptionsForSelect(){
    return [{label:'時間', value:0}, {label:'日', value:1}];
  }
  
  static birthYearOptionsForSelect(){
    let years = [];
    const date = new Date();
    const min = date.getFullYear() - 100;
    const max = date.getFullYear() - 20;
    for (let year = min; year <= max; year++) {
      years.push({ label:year, value:year});
    }
    
    return years;
  }

  static corpFoundYearOptionsForSelect(){
    let years = [];
    const date = new Date();
    const min = date.getFullYear() - 150;
    const max = date.getFullYear() - 0;
    for (let year = min; year <= max; year++) {
      years.push({ label:year, value:year});
    }
    
    return years;
  }
  
  static monthOptionsForSelect(){
    let months = [];
    for (let month = 1; month <= 12; month++) {
      months.push({ label:month, value:month});
    }
    
    return months;
  }
  
  static dayOptionsForSelect(){
    let days = [];
    for (let day = 1; day <= 31; day++) {
      days.push({ label:day, value:day});
    }
    
    return days;
  }
}
export default SMFormHelper;



// WEBPACK FOOTER //
// ./app/javascript/components/helpers/SMFormHelper.js